var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pui-flex',{staticClass:"poster-default-viewer",attrs:{"flex":"1","justifyContent":"center"}},[_c('poster-gallery-thumbnail',{attrs:{"posterId":_vm.posterRequest.itemId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }